import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AGSLayer} from './AGSLayer';

@Injectable()
export class AGSLayerList {
  public  agsLayer: AGSLayer;
  public layerListArr: Array<AGSLayer>;
  public layerListObj: any = {};
  public visibleLayerListArr: Array<AGSLayer>;
  public parentLayerList: {};
  public layerParentDict: any;
  public layerDictionary: any;
  private layerAdded = new BehaviorSubject<any>(this);
  public layerAdded$ = this.layerAdded.asObservable();

  constructor() {
    this.visibleLayerListArr = [];
    this.layerListArr = [];
    this.parentLayerList = {};
  }

  public addLayerToList(agsLayer: AGSLayer) {
    this.layerListArr.push(agsLayer);
    this.layerListObj[agsLayer.serviceLayerID] = agsLayer;
  }

  public getLayerElemByID(serviceLayerID) {
    return this.layerListObj[serviceLayerID];
  }

  public updateLayersList(mapRefLayers: any) {
    // Populate visibleLayerListArr in order of layers on the map
    this.visibleLayerListArr = [];
    let ctr = 0;
    for (let i = mapRefLayers.length - 1; i > -1; i--) {
      const mapLayerObj = mapRefLayers[i];
      const layerElem = this.findLayerInVisibleLayerListByID(mapLayerObj.id);
      if (layerElem !== undefined && layerElem != null) {
        layerElem.layerOrder = ctr;
        this.visibleLayerListArr.push(layerElem);
      }
      ctr++;
    }
    return this.visibleLayerListArr;
  }

  public addLayerToVisibleLayerList(agsLayer: AGSLayer) {
    this.addLayerToDictionary(agsLayer.serviceLayerID, agsLayer);
    this.layerAdded.next(agsLayer);
  }

  public moveLayerInVisibleLayerList(agsLayer: AGSLayer, position: number) {
    // Move layer to a specific position in array to reflect the order on the map
    // Check to see if this element exists in visibleLayerListArr
    if (this.visibleLayerListArr[position] !== undefined) {
      // Add layer to specified position
      this.visibleLayerListArr[position] = agsLayer;
    }
  }


  public findLayerInVisibleLayerListByID(serviceLayerID: string) {
    if (this.layerDictionary !== undefined && this.layerDictionary[serviceLayerID] !== undefined) {
      return this.layerDictionary[serviceLayerID];
    } else {
      return null;
    }
  }

  public removeLayerFromVisibleLayerList(agsLayer: AGSLayer) {
    // Remove layer from visibleLayerListArr
    for (let i = 0; i < this.visibleLayerListArr.length; i++) {
      if (this.visibleLayerListArr[i].serviceLayerID === agsLayer.serviceLayerID) {
        this.visibleLayerListArr.splice(i, 1);
        break;
      }
    }
  }

  public removeLayerFromVisibleLayerListByID(svcLayerID: string) {
    // Remove layer from visibleLayerListArr
    for (let i = 0; i < this.visibleLayerListArr.length; i++) {
      if (this.visibleLayerListArr[i].serviceLayerID === svcLayerID) {
        this.visibleLayerListArr.splice(i, 1);
        break;
      }
    }
  }

  public getVisibleLayerList() {
    const currentVisLayerArr = [];
    for (const visLayer of this.visibleLayerListArr) {
      if (visLayer && ((visLayer.mapImageLayer && visLayer.mapImageLayer.visible) ||
        (visLayer.featureLayer && visLayer.featureLayer.visible)) &&
        (visLayer.isVisible === undefined || visLayer.isVisible)) {
        currentVisLayerArr.push(visLayer);
      }
    }
    return currentVisLayerArr;
  }

  public addLayerToDictionary(serviceLayerID: string, layerElem: AGSLayer) {
    // Creates a dictionary by layer id (serviceLayerID) with the layerElem as the value
    // this.layerDictionary["Faults 24K"] will return the layerElem
    if (this.layerDictionary === undefined) {
      const layerDictionary: {
        [index: string]: AGSLayer; } = {};
      layerDictionary[serviceLayerID] = layerElem;
      this.layerDictionary = layerDictionary;
    } else {
      this.layerDictionary[serviceLayerID] = layerElem;
    }
  }

  public addLayerToParentList(parentNode: any, agsLayer: AGSLayer) {
    // Add layer to parentLayerList
    if (this.parentLayerList[parentNode] !== undefined) {
      // Add layer to parentNode in parentLayerList
      const parentArr = this.parentLayerList[parentNode];
      parentArr.push(agsLayer);
    } else {
      // Create parent object and add layer
      this.parentLayerList[parentNode] = [];
      this.parentLayerList[parentNode].push(agsLayer);
    }
  }

  public removeLayersFromParentList(parentNode: any, layerList: Array<any>, removeAllLayers: boolean) {
    // Remove layers from parentLayerList

    if (this.parentLayerList[parentNode.id] !== undefined) {
      const parentLayerArr = this.parentLayerList[parentNode.id];
      if (removeAllLayers) {
        // Get all layers in parent node
        layerList = parentLayerArr;
      }
      for (const layer of layerList) {
        // Remove layer from visible layer list
        if (removeAllLayers) {
          this.removeLayerFromVisibleLayerListByID(layer.serviceLayerID);
        } else {
          this.removeLayerFromVisibleLayerListByID(layer);
          // Remove layer from parent node
          const arrIndex = parentLayerArr.findIndex(
            parentLayerArr.filter(x => {
              return x.serviceLayerID === layer;
            })
          );
          if (arrIndex && arrIndex > -1) {
            parentLayerArr.splice(arrIndex);
          }
        }
      }
    }
    if (removeAllLayers) {
      // Remove all layers from parent list
      this.parentLayerList[parentNode.id] = [];
    }

  }

  public addLayerParentRelationship(serviceLayerID: string, parentName: string) {
    // Creates a dictionary by layer id (serviceLayerID) with the parentName as the value
    // this.layerParentDict["Faults 24K"] will return the parent folder "1:24,000-scale Geologic Mapping"
    if (this.layerParentDict === undefined) {
      const layerParentDict: {
        [index: string]: string; } = {};
      layerParentDict[serviceLayerID] = parentName;
      this.layerParentDict = layerParentDict;
    } else {
      this.layerParentDict[serviceLayerID] = parentName;
    }
  }

  public getLayersForParent(parentNode: any) {
    // get all layers for a specific parent
    if (this.parentLayerList[parentNode] !== undefined) {
      return this.parentLayerList[parentNode];
    } else {
      return null;
    }
  }

}
